(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('[data-tutorial-archive]');

    roots.forEach((root) => {
      const grid = root.querySelector('[data-tutorial-grid]');
      const cards = Array.from(root.querySelectorAll('[data-tutorial-card]'));
      const tabs = Array.from(root.querySelectorAll('[data-tutorial-tab]'));
      const pager = root.querySelector('[data-tutorial-pagination]');
      const pagesWrap = root.querySelector('[data-tutorial-pages]');
      const prev = root.querySelector('[data-tutorial-prev]');
      const next = root.querySelector('[data-tutorial-next]');

      if (!grid || !cards.length) return;

      const pageSize = Number(grid.dataset.pageSize || 9);
      let activeCategory = '__all';
      let page = 1;

      function filteredCards() {
        if (activeCategory === '__all') return cards;

        return cards
          .filter((card) => card.dataset.tutorialCategory === activeCategory)
          .sort((a, b) => {
            const priorityDifference = Number(b.dataset.tutorialSortPriority || 0) - Number(a.dataset.tutorialSortPriority || 0);

            if (priorityDifference !== 0) return priorityDifference;

            return Number(a.dataset.tutorialPosition || 0) - Number(b.dataset.tutorialPosition || 0);
          });
      }

      function renderPages(totalPages) {
        if (!pagesWrap) return;
        pagesWrap.innerHTML = '';

        for (let i = 1; i <= totalPages; i += 1) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = `tutorialArchive__page${i === page ? ' is-active' : ''}`;
          btn.textContent = i;
          const S = (window.gwaStrings && window.gwaStrings.tutorial_blog) || {};
          btn.setAttribute('aria-label', S.page ? S.page.replace('__N__', i) : `Page ${i}`);
          btn.setAttribute('aria-current', i === page ? 'page' : 'false');
          btn.addEventListener('click', () => {
            page = i;
            render();
            grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          pagesWrap.appendChild(btn);
        }
      }

      function render() {
        const visibleCards = filteredCards();
        const totalPages = Math.max(1, Math.ceil(visibleCards.length / pageSize));
        page = Math.min(page, totalPages);
        const start = (page - 1) * pageSize;
        const end = start + pageSize;

        const renderOrder = activeCategory === '__all'
          ? cards
          : [...visibleCards, ...cards.filter((card) => card.dataset.tutorialCategory !== activeCategory)];

        renderOrder.forEach((card) => grid.appendChild(card));

        cards.forEach((card) => {
          card.style.display = 'none';
        });
        visibleCards.slice(start, end).forEach((card) => {
          card.style.display = '';
        });

        if (pager) pager.style.display = totalPages > 1 ? 'flex' : 'none';
        if (prev) prev.disabled = page <= 1;
        if (next) next.disabled = page >= totalPages;
        renderPages(totalPages);
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activeCategory = tab.dataset.tutorialTab;
          page = 1;
          tabs.forEach((item) => {
            const selected = item.dataset.tutorialTab === activeCategory;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
          render();
        });
      });

      if (prev) {
        prev.addEventListener('click', () => {
          page = Math.max(1, page - 1);
          render();
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          page += 1;
          render();
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      render();
    });
  });
})();
